import { localCatch, sessionCatch } from '@/utils'

/**
 * 是否需要设置缓存
 * @param {String,Object} name接口name值
 * @param {String,Object} catchName缓存名称, 存在该值表示要缓存
 * @param {String} catchName.position值后缀拼接位置position after或者before，目前只支持从接口参数中取值
 * @param {String} catchName.storage不存在则去取请求参数
 * @param {String} catchName.keyStorage: 'usersInfo',超前获取到用户数据 并覆盖storage的值
 * @param {String} removeName 删除的键值,多个逗号隔开（键值是RequestListConfig下的属性）
 * @param {Boolern} persistence是否是持久化缓存 true => localStrong  false => sessionStrong  默认为true
 * @param {String} type 请求类型		get 或者 post 之类
 * @param {Boolern} abort 是否中断请求（如果有缓存是不会其你去的）默认值是true
 * @param {Object, String} timeKey 缓存时间字段
 * @param {Function} catchBefore 缓存之前做的操作，比如一些计算
 * @param {String} update强制更新数据接口=>目前只做删除，后续可以考虑加上自动请求更新掉旧数据,只会更新白名单里面的缓存,强制更新他人的  必须请求
 * @param {String} showErr提示错误信息（如果有缓存是不会其你去的）默认值是true
 * @param {String} showModal提示弹窗错误信息（如果有缓存是不会其你去的）默认值是true
 * @param {String} modalBack返回按钮是否是上一页
 *
 */
import { PROXY_NAME } from '@/config'
const LOGIN_KEY = 'accessInfo';
const USERINFO_KEY = 'userInfo';

const RequestListConfig = {
	getVenueInfoByContentId: {
		url: '/api/resource/getVenueInfoByContentId',
		name: '获取经纬度',
		type: 'get'
	},
	login: {
		url: '/login',
		name: '用户登录接口',
		loading: '正在登录',
		toast: '登录成功',
		catchName: LOGIN_KEY,
		abort: false
	},
	logout: {
		url: '/logout',
		name: '退出登录',
		loading: '正在登出'
	},
	indexLBT: {
		url: '/api/index/lbt',
		name: '首页-轮播图',
		desc: '获取首页轮播图列表数据',
		type: 'get'
	},
	indexPC: {
		url: '/api/index/zxpc',
		name: '首页-飘窗',
		desc: '获取首页飘窗列表数据',
		type: 'get'
	},
	resourcePage: {
		url: '/api/resource/page',
		name: '获取文章列表',
		type: 'get'
	},
	resourceDetail: {
		url: '/api/resource/',
		name: '获取文章详情',
		type: 'get',
		loading: '加载中'
	},
	activityDetail: {
		url: '/api/activity/',
		name: '查询活动详情',
		type: 'get',
		loading: '加载中'
	},
	indexNews: {
		url: '/api/index/news',
		name: '首页-资讯接口',
		type: 'get'
	},
	indexWonderfulTrain: {
		url: '/api/index/wonderfulTrain',
		name: '首页-大兴非遗接口',
		type: 'get'
	},
	register: {
		url: '/register',
		name: '用户注册接口',
		loading: '正在注册',
		toast: '注册成功'
	},
	sendPhoneMsg: {
		url: '/register/sendPhoneMsg',
		name: '注册-获取注册验证码',
		loading: '加载中',
		toast: '验证码发送成功'
	},
	rectrievePwd: {
		url: '/register/rectrieve/phone',
		name: '找回密码',
		loading: '提交中',
		toast: '密码找回成功'
	},
	firstOfChannelPath: {
		url: '/api/resource/firstOfChannelPath',
		name: '大兴文化馆概况',
		type: 'get',
		loading: '加载中'
	},
	resourceUp: {
		url: '/api/resource/up',
		name: '点赞操作',
		modalBack: false,
		toast: '点赞成功'
	},
	resourceCancelUp: {
		url: '/api/resource/cancelUp',
		type: 'post',
		name: '取消点赞操作',
		modalBack: false,
		toast: '取消点赞成功'
	},
	collection: {
		url: '/api/resource/collection',
		name: '收藏操作',
		modalBack: false,
		toast: '收藏成功'
	},
	collectionCancel: {
		url: '/api/resource/collection/cancel',
		name: '取消收藏操作',
		modalBack: false,
		toast: '取消收藏成功'
	},
	activityPage: {
		url: '/api/activity/activityPage',
		name: '查询活动列表',
		type: 'get'
	},
	searchWordList: {
		url: '/api/resource/searchWordList',
		name: '搜索热词',
		type: 'get'
	},
	encorePage: {
		url: '/api/resource/encorePage',
		name: '精彩返场',
		type: 'get'
	},
	encoreDetail: {
		url: '/api/resource/encoreDetail',
		name: '获取返场详情',
		loading: '加载中',
		type: 'get'
	},
	culturalPage: {
		url: '/api/cultural/page',
		name: '文化圈子列表',
		type: 'get'
	},
	culturalClassify: {
		url: '/api/cultural/classify',
		name: '圈子分类',
		type: 'get'
	},
	contentInteractiveInfo: {
		url: '/api/resource/contentInteractiveInfo',
		name: '内容交互信息（是否点赞、收藏）',
		type: 'get'
	},
	// 评论相关
	commentLatest: {
		url: '/api/comment/page/latest',
		name: '评论列表',
		type: 'get'
	},
	comment: {
		url: '/api/comment',
		name: '发表评论',
		loading: '正在发表评论',
		toast: '评论成功，请等待审核',
		modalBack: false
	},
	commentById: {
		url: '/api/comment/',
		name: '获取单个评论',
		type: 'get'
	},
	commentCount: {
		url: '/api/comment/count/',
		name: '获取评论总数',
		type: 'get'
	},
	getActivitySignCount: {
		url: '/api/resource/getActivitySignCount/',
		name: '获取报名总数',
		type: 'get'
	},
	isAllowComment: {
		url: '/api/resource/isAllowComment',
		name: '是否允许评论',
		type: 'get'
	},
	childrenComment: {
		url: '/api/comment/childrenComment',
		name: '获取自身及子评论列表',
		loading: '加载中',
		type: 'get'
	},
	commentUp: {
		url: '/api/comment/up',
		name: '评论的点赞'
	},
	commentCancelUp: {
		url: '/api/comment/cancel/up',
		name: '评论的取消点赞'
	},
	contentType: {
		url: '/api/resource/contentType',
		name: '获取文章类型',
		loading: '加载中',
		type: 'get'
	},
	addEncoreHeats: {
		url: '/api/resource/addEncoreHeats',
		name: '增加热度',
		loading: '加载中',
		toast: '加热度成功',
		type: 'get'
	},
	subSitePage: {
		url: '/api/resource/subSitePage',
		name: '本馆文化资讯',
		type: 'get'
	},
	subSiteActivityPage: {
		url: '/api/activity/subSiteActivityPage',
		name: '本馆活动资讯',
		type: 'get'
	},
	tagList: {
		url: '/api/center/tagList',
		name: '标签(我感兴趣的)',
		loading: '加载中',
		type: 'get',
		catchBefore: (data) => {
			return data.map(o => {
				o.tagId = String(o.tagId);
				return o;
			});
		}
	},
	selectTags: {
		url: '/api/center/selectTags',
		name: '设置标签',
		loading: '加载中',
		type: 'get',
		toast: '设置成功'
	},
	userInfo: {
		url: '/api/center/userInfo',
		loading: '加载中',
		type: 'get',
		catchName: USERINFO_KEY
	},
	updatePwd: {
		url: '/api/center/updatePwd',
		loading: '加载中',
		type: 'get',
		toast: '修改成功'
	},
	activityRegister: {
		url: '/api/activity/apimember/register',
		loading: '加载中',
		toast: '报名成功'
	},
	collectionPage: {
		url: '/api/resource/collection/page',
		name: '我的收藏',
		type: 'get'
	},
	myActivityPage: {
		url: '/api/activity/apimember/myActivityPage',
		name: '我报名的活动',
		type: 'get'
	},
	memberinfoCustom: {
		url: '/member/memberinfo/custom',
		name: '修改头像',
		type: 'put',
		toast: '头像修改成功'
	},
	updateUserInfo: {
		url: '/api/center/updateUserInfo',
		name: '修改个人资料',
		loading: '加载中',
		toast: '修改成功'
	},
	follow: {
		url: '/api/cultural/apimember/follow',
		name: '我的关注列表',
		toast: '关注成功'
	},
	cancelFollow: {
		url: '/api/cultural/apimember/cancelFollow',
		name: '取消关注',
		toast: '已取消关注'
	},
	followPage: {
		url: '/api/cultural/apimember/followPage',
		name: '关注列表',
		type: 'get'
	},
	userFollowPage: {
		url: '/api/cultural/userFollowPage',
		name: 'TA的关注列表',
		type: 'get'
	},
	fansPage: {
		url: '/api/cultural/apimember/fansPage',
		name: '粉丝列表',
		type: 'get'
	},
	userCultralPage: {
		url: '/api/cultural/userCultralPage',
		name: '用户圈子列表',
		type: 'get'
	},
	kaptcha: {
		url: '/common/kaptcha',
		name: '获取图形码',
		type: 'get'
	},
	feedbackForm: {
		url: '/api/index/feedbackForm',
		name: '获取意见反馈表单',
		type: 'get',
		loading: '加载中'
	},
	smartForm: {
		url: '/smartForm',
		name: '提交意见反馈'
	},
	questionnaireForm: {
		url: '/api/index/questionnaireForm',
		name: '获取问卷调查表单',
		type: 'get',
		loading: '加载中'
	},
	questionnaire: {
		url: '/questionnaire',
		name: '获取问卷调查表单',
		toast: '提交完成',
		loading: '正在提交'
	},
	mobileAuthcode: {
		url: '/register/mobile/authcode',
		name: '验证手机验证码',
		type: 'get',
		loading: '身份验证中'
	},
	updateMobile: {
		url: '/api/center/updateMobile',
		name: '修改手机号',
		type: 'get',
		loading: '加载中'
	},
	phoneUnique: {
		url: '/register/phone/unique',
		name: '验证手机号是否合法',
		type: 'get'
	},
	signIn: {
		url: '/api/signIn/apimember/signIn',
		name: '用户签到接口',
		type: 'get',
		showErr: false
	},
	signInRecord: {
		url: '/api/signIn/apimember/record',
		name: '签到记录',
		type: 'get'
	},
	myCultralPage: {
		url: '/api/cultural/apimember/myCultralPage',
		name: '我的圈子列表',
		type: 'get'
	},
	memberTalkPage: {
		url: '/api/message/apimember/memberTalkPage',
		name: '私信消息列表',
		type: 'get'
	},
	inbox: {
		url: '/api/message/apimember/inbox',
		name: '系统私信收件箱',
		type: 'get'
	},
	sendMessage: {
		url: '/api/message/apimember/sendMessage',
		name: '发送消息',
		toast: '发送成功'
	},
	culturalMemberInfo: {
		url: '/api/cultural/memberInfo',
		name: '圈友详情',
		type: 'get'
	},
	memberTalkDetailsPage: {
		url: '/api/message/apimember/memberTalkDetailsPage',
		name: '用户对话详情列表',
		type: 'get'
	},
	culturalDelete: {
		url: '/api/cultural/apimember/delete',
		name: '删除我的圈子'
	},
	culturalIssue: {
		url: '/api/cultural/apimember/issue',
		name: '发圈',
		loading: '正在发布',
		toast: '发布成功，请等待后台管理员审核'
	},
	myCollection: {
		url: '/api/cultural/apimember/myCollection',
		name: '圈子收藏列表',
		type: 'get'
	},
	hotActivityPage: {
		url: '/api/activity/hotActivityPage',
		name: '查询热门活动列表',
		type: 'get'
	},
	indexActivityPage: {
		url: '/api/index/activityPage',
		name: '首页活动列表',
		type: 'get'
	},
	sysMsgPage: {
		url: '/api/center/sysMsgPage',
		name: '分页获取系统消息列表',
		type: 'get'
	},
	sysMsgDetail: {
		url: '/api/center/sysMsg/',
		name: '获取系统消息详情',
		type: 'get'
	},
	channelIntro: {
		url: '/api/resource/channelIntro',
		name: '获取栏目图片',
		type: 'get'
	},
	volunteerStatus: {
		url: '/api/center/volunteerStatus',
		name: '获取志愿者状态',
		type: 'get',
		modalBack: true
	},
	volunteerInfo: {
		url: '/api/center/volunteerInfo',
		name: '获取志愿者信息',
		type: 'get',
		loading: ''
	},
	updateVolunteer: {
		url: '/api/center/updateVolunteer',
		name: '更新志愿者信息',
		toast: '已提交审核，请耐心等待结果',
		loading: '正在提交'
	},
	volunteerProjQrCodeInfo: {
		url: '/api/center/volunteerProjQrCodeInfo',
		name: '获取志愿者项目二维码信息',
		type: 'get'
	},
	scoreDetails: {
		url: '/member/memberinfo/scoreDetails',
		name: '积分列表',
		type: 'get'
	},
	interactionPage: {
		url: '/member/interaction/page',
		name: '我的互动',
		type: 'get'
	},
	scoreCenSus: {
		url: '/member/memberinfo/scoreCenSus',
		name: '用户积分统计',
		type: 'get'
	},
	linkList: {
		url: '/link/listAll',
		name: '获取友情链接',
		type: 'get'
	},
	prodList: {
		url: '/api/prod/page',
		name: '获取兑换商品',
		type: 'get'
	},
	isExchange: {
		url: '/api/order/isExchange',
		name: '检查商品是否可兑换',
		type: 'get'
	},
	orderSave: {
		url: '/api/order/save',
		type: 'post',
		name: '商品兑换',
		loading: '正在兑换',
		toast: '兑换成功'
	},
	orderList: {
		url: '/api/order/page',
		name: '获取兑换记录',
		type: 'get'
	},
}


export const FormUrlNameArr = ['updateUserInfo', 'login', 'smartForm', 'questionnaire'];

export const FormUrlEnCodedUrl = (() => {
	let list = [];
	for (var key in RequestListConfig) {
		if(FormUrlNameArr.findIndex(o => key === o) !== -1){
			list.push(RequestListConfig[key].url)
		}
	}
	return list;
})();


// 需要缓存的列表计算
export const needCatchList = (() => { //只执行一次，减少开销
	let list = {};
	for (var key in RequestListConfig) {
		var item = RequestListConfig[key];
		// #ifdef H5
		if(process.env.NODE_ENV === 'development'){
			item.url = PROXY_NAME + item.url;
		}
		// #endif
		item.persistence = isExitValue(item, 'persistence') ? item.persistence : true;
		item.catchBefore = isExitValue(item, 'catchBefore') ? item.catchBefore : false;
		item.showErr = isExitValue(item, 'showErr') ? item.showErr : true;
		item.showModal = isExitValue(item, 'showModal') ? item.showModal : true;
		item.abort = isExitValue(item, 'abort') ? item.abort : true;
		item.modalBack = isExitValue(item, 'modalBack') ? item.modalBack : true;
		list[key] = item;
	}
	return list
})();

// 用户缓存方法
export function apiStorage(key = 'login') {
	let obj = needCatchList[key];
	return {
		get: () => {
			return (obj.persistence ? localCatch : sessionCatch).get(obj.catchName)
		},
		set: (data) => {
			return (obj.persistence ? localCatch : sessionCatch).get(obj.catchName, data)
		},
		remove: () => {
			return (obj.persistence ? localCatch : sessionCatch).remove(obj.catchName)
		}
	}
};

export function getLoginInfo() {
	return apiStorage().get() || {};
}

export function getUserInfo() {
	return apiStorage('userInfo').get() || {};
}

export function removeLoginInfo() {
	return apiStorage().remove();
}

export function removeUserInfo() {
	return apiStorage('userInfo').remove();
}


/**
 * @description 判断对象是否存在键值
 * @param {Object} obj 要查找的对象
 * @param {String} key 对象键值
 * @return {Boolean} 返回一个布尔值
 */
function isExitValue(obj, key) {
	if (obj.hasOwnProperty(key) === false || obj[key] === undefined || obj[key] === null || obj[key] === '') return false;
	return true;
}
